import { Field, Formik, FormikHelpers } from 'formik'

import Box from '@totallymoney/ui/components/Box'
import Button from '@totallymoney/ui/components/Button'
import Heading from '@totallymoney/ui/components/Heading'
import Stack from '@totallymoney/ui/components/Stack'
import Text from '@totallymoney/ui/components/Text'
import theme from '@totallymoney/ui/theme'

import { LoanTableFilterFormValues } from '@appTypes/App.interface'

import FormikTextField from '@components/form/FormikTextField'

import formatNumberToCurrency from '@utils/formatNumberToCurrency'
import { LoanFilterLimits } from '@utils/getCategoryLoanFilterLimits'

import FormikLoanPurposeSelect from './components/FormikLoanPurposeSelect'
import FormikLoanTermSelect from './components/FormikLoanTermSelect'

interface LoansTableFilterFormProps {
    formValues: LoanTableFilterFormValues
    loanFilterLimits: LoanFilterLimits
    onFormSubmit: (
        formValues: LoanTableFilterFormValues,
        formikHelpers: FormikHelpers<LoanTableFilterFormValues>
    ) => void
    showLoanPurpose?: boolean
    validationSchema: any
}

const LoansTableFilterForm = ({
    formValues,
    loanFilterLimits,
    onFormSubmit,
    showLoanPurpose,
    validationSchema,
}: LoansTableFilterFormProps) => (
    <Formik
        initialValues={formValues}
        onSubmit={onFormSubmit}
        validate={validationSchema}
        validateOnBlur={true}
        validateOnChange={false}
    >
        {({ submitForm, isSubmitting, setFieldValue, status }) => (
            <>
                <Stack
                    direction="column"
                    width="100%"
                    space="space30"
                    maxWidth="384px"
                    margin="auto"
                    mb="space30"
                >
                    <Heading variant="80">Loan details</Heading>

                    <Field
                        name="loanAmount"
                        labelText="How much would you like to borrow?"
                        helperText={`${formatNumberToCurrency(loanFilterLimits.loanAmount.min)} - ${formatNumberToCurrency(loanFilterLimits.loanAmount.max)}`}
                        component={FormikTextField}
                        prefix="£"
                        type="number"
                        onFocus={() => setFieldValue('loanAmount', '')}
                    />

                    <FormikLoanTermSelect />

                    {showLoanPurpose ? <FormikLoanPurposeSelect /> : null}

                    <Box display="flex" justifyContent="center">
                        <Button
                            variant="primary"
                            text="Update results"
                            type="submit"
                            loading={isSubmitting}
                            onClick={() => submitForm()}
                        />
                    </Box>
                </Stack>

                {status ? (
                    <Box mt="space10">
                        <Text style={{ color: theme.errorDark }}>
                            Something went wrong while submitting the form,
                            please try again.
                        </Text>
                    </Box>
                ) : null}
            </>
        )}
    </Formik>
)

export default LoansTableFilterForm
